import Loadable from 'react-loadable';
import AsyncLoading from 'pages/AsyncPageLoading';

export default opts =>
  Loadable(
    Object.assign(
      {
        LoadingComponent: AsyncLoading,
        // delay: 200,
        // timeout: 10,
      },
      opts,
    ),
  );
